var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55.4615385,
    y1: 32.5,
    x2: 67,
    y2: 28,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4BF48",
    cx: 41,
    cy: 41,
    r: 41
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F7D34D",
    cx: 38,
    cy: 40.5,
    rx: 38,
    ry: 37.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.3828125,49.2714844 C50.1347656,66.609375 27.7134801,66.7069248 19,48",
    id: "Path-3",
    stroke: "#594238",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Heart_995106",
    transform: "translate(11.000000, 22.000000)",
    fill: "#C3393C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57903489,16.9542061 L9.5030591,17 L9.45747363,16.9713788 C-4.93233982,8.28388564 0.00608612476,-0.100222612 5.34718373,0.000905685304 C5.51812924,0.000905685304 5.69097415,0.018078415 5.86191966,0.0390673068 C8.01203435,0.300474414 9.02441167,1.49874933 9.5030591,2.52911311 C9.97980715,1.49874933 10.9940839,0.300474414 13.1441985,0.0486077122 C18.6505435,-0.632577232 24.3848158,7.99194924 9.57903489,16.9542061 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Heart_995106",
    transform: "translate(52.000000, 22.000000)",
    fill: "#C3393C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57903489,16.9542061 L9.5030591,17 L9.45747363,16.9713788 C-4.93233982,8.28388564 0.00608612476,-0.100222612 5.34718373,0.000905685304 C5.51812924,0.000905685304 5.69097415,0.018078415 5.86191966,0.0390673068 C8.01203435,0.300474414 9.02441167,1.49874933 9.5030591,2.52911311 C9.97980715,1.49874933 10.9940839,0.300474414 13.1441985,0.0486077122 C18.6505435,-0.632577232 24.3848158,7.99194924 9.57903489,16.9542061 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyLove);
export default __webpack_public_path__ + "static/media/Smiley_love.c630930be8ede7bfe0cb2c3552164c63.svg";
export { ForwardRef as ReactComponent };